import { useState } from "react";
import { siteInfo } from "@/mocks/manga";

const quickTags = ["80后童年", "90后童年", "00后童年", "绝版漫", "国漫黄金年代", "旧刊扫描"];

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  return (
    <section
      id="hero"
      className="relative flex min-h-[600px] w-full items-center overflow-hidden md:h-[640px]"
    >
      <img
        src="https://readdy.ai/api/search-image?query=nostalgic%20retro%20manga%20comic%20pile%20on%20warm%20wooden%20desk%20old%20manga%20magazines%20stacked%20warm%20sepia%20amber%20tones%20vintage%20childhood%20memory%20cozy%20study%20corner%20with%20soft%20lamp%20light%20hand%20drawn%20illustration%20style%20warm%20cream%20and%20brown%20palette&width=1600&height=900&seq=hero-073&orientation=landscape"
        alt="073漫画网老漫画补档怀旧背景，泛黄的老漫画与旧刊堆叠在书桌上"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/65"></div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 py-16 text-center md:px-6">
        <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-200/40 bg-background-50/10 px-4 py-1.5 text-sm text-background-100 backdrop-blur-sm">
          <i className="ri-time-line text-base"></i>
          老漫画补档 · 经典老番考古 · 童年漫画绝版资源
        </p>
        <h1 className="mx-auto max-w-3xl font-heading text-3xl leading-tight text-background-50 md:text-5xl">
          找回记忆里的老漫画，补完当年没看完的旧坑
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          {siteInfo.description}
        </p>

        <form
          className="mx-auto mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row sm:items-center sm:rounded-full sm:border sm:border-background-200/40 sm:bg-background-50/10 sm:p-1.5 sm:backdrop-blur-sm"
          onSubmit={(e) => e.preventDefault()}
        >
          <label htmlFor="heroSearch" className="sr-only">
            搜索老漫画
          </label>
          <div className="relative flex-1">
            <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-background-200"></i>
            <input
              id="heroSearch"
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画名称 / 作者 / 年代…"
              className="w-full rounded-full border border-background-200/40 bg-background-50/10 py-3 pl-11 pr-4 text-sm text-background-50 placeholder:text-background-200 focus:border-primary-300 focus:outline-none sm:border-0 sm:bg-transparent"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始找漫
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {quickTags.map((tag) => (
            <span
              key={tag}
              className="cursor-pointer rounded-full border border-background-200/40 px-3 py-1.5 text-xs text-background-100 transition-colors hover:bg-background-50/10"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-8">
          <div>
            <p className="font-heading text-2xl text-background-50 md:text-3xl">580+</p>
            <p className="mt-1 text-xs text-background-200">收录老漫画</p>
          </div>
          <div className="h-10 w-px bg-background-200/40"></div>
          <div>
            <p className="font-heading text-2xl text-background-50 md:text-3xl">30+</p>
            <p className="mt-1 text-xs text-background-200">年代与题材</p>
          </div>
          <div className="h-10 w-px bg-background-200/40"></div>
          <div>
            <p className="font-heading text-2xl text-background-50 md:text-3xl">12w+</p>
            <p className="mt-1 text-xs text-background-200">怀旧漫爱好者</p>
          </div>
        </div>
      </div>
    </section>
  );
}